import React, { useEffect, useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'
import { preventOrphan } from '../../utils'

import {
  productDetail,
  productDetailsContainer,
  productDetailsWrapper,
  image,
  productDetailsInfo,
  details,
  productCta,
  divider,
  desktopCtaBlockWrapper,
  ctaBlock,
  cta,
  threeProductDetails,
  ctaOnlyBlock,
} from './index.module.css'

import useWindowSize from '../../hooks/useWindowSize'

const ProductDetails = ({ components, title, ctaText, ctaUrl, nodeLocale }) => {
  const size = useWindowSize()
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    if (size.width) {
      setIsDesktop(size.width >= 1279)
    }
  }, [size.width])

  const orderedProductDetails = (components || [])
    .slice()
    .sort((a, b) => a.order - b.order)

  return (
    <div className={productDetailsContainer}>
      <div
        className={[
          productDetailsWrapper,
          orderedProductDetails.length === 3 ? threeProductDetails : '',
        ].join(' ')}
      >
        {orderedProductDetails
          .slice(0, isDesktop ? 3 : 4)
          .map((productDetails, index) => (
            <Link
              key={index}
              className={[productDetail].join(' ')}
              to={productDetails.ctaUrl}
            >
              {productDetails.image && (
                <GatsbyImage
                  image={productDetails.image.gatsbyImageData}
                  className={image}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: '50% 50%',
                  }}
                  alt={productDetails.image?.description}
                />
              )}
              {productDetails.title && <h4>{productDetails.title}</h4>}
              {productDetails.subtitle.subtitle && (
                <h3>{productDetails.subtitle.subtitle}</h3>
              )}
              <div className={productDetailsInfo}>
                {productDetails.fov && (
                  <span className={details}>{productDetails.fov}</span>
                )}
                {productDetails.focalLength && (
                  <span className={details}>{productDetails.focalLength}</span>
                )}
                {productDetails.ctaUrl && productDetails.ctaText && (
                  <Link className={productCta} to={productDetails.ctaUrl}>
                    {productDetails.ctaText}
                  </Link>
                )}
              </div>
            </Link>
          ))}
      </div>
      {orderedProductDetails[3] ? (
        <>
          <div className={divider} />
          {isDesktop ? (
            <div
              className={productDetailsWrapper}
              style={{ borderBottom: 'none' }}
            >
              <div className={productDetail}>
                {orderedProductDetails[3].title && (
                  <h4>{orderedProductDetails[3].title}</h4>
                )}
                {orderedProductDetails[3].subtitle.subtitle && (
                  <h3>{orderedProductDetails[3].subtitle.subtitle}</h3>
                )}
                <div className={productDetailsInfo}>
                  {orderedProductDetails[3].fov && (
                    <span className={details}>
                      {orderedProductDetails[3].fov}
                    </span>
                  )}
                  {orderedProductDetails[3].focalLength && (
                    <span className={details}>
                      {orderedProductDetails[3].focalLength}
                    </span>
                  )}
                  {orderedProductDetails[3].ctaUrl &&
                    orderedProductDetails[3].ctaText && (
                      <Link
                        className={productCta}
                        to={orderedProductDetails[3].ctaUrl}
                      >
                        {orderedProductDetails[3].ctaText}
                      </Link>
                    )}
                </div>
              </div>
              {orderedProductDetails[3].ctaUrl &&
              orderedProductDetails[3].image ? (
                <Link
                  className={productDetail}
                  to={orderedProductDetails[3].ctaUrl}
                >
                  <GatsbyImage
                    image={orderedProductDetails[3].gatsbyImageData}
                    className={image}
                    imgStyle={{
                      objectFit: 'contain',
                      objectPosition: '50% 50%',
                    }}
                    alt={orderedProductDetails[3].image?.description}
                  />
                </Link>
              ) : (
                orderedProductDetails[3].image && (
                  <GatsbyImage
                    image={orderedProductDetails[3].gatsbyImageData}
                    className={image}
                    imgStyle={{
                      objectFit: 'contain',
                      objectPosition: '50% 50%',
                    }}
                    alt={orderedProductDetails[3].image?.description}
                  />
                )
              )}

              <div
                className={[productDetail, desktopCtaBlockWrapper].join(' ')}
              >
                <div className={ctaBlock}>
                  {title && (
                    <h2>
                      {nodeLocale.indexOf('jp') !== -1
                        ? preventOrphan(title)
                        : title}
                    </h2>
                  )}
                  {ctaUrl && ctaText && (
                    <Link className={cta} to={ctaUrl}>
                      {ctaText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className={ctaBlock}>
              {title && (
                <h2>
                  {nodeLocale.indexOf('jp') !== -1
                    ? preventOrphan(title)
                    : title}
                </h2>
              )}
              {ctaUrl && ctaText && (
                <Link className={cta} to={ctaUrl}>
                  {ctaText}
                </Link>
              )}
            </div>
          )}
        </>
      ) : (
        <div className={ctaOnlyBlock}>
          {(title || (ctaUrl && ctaText)) && <div className={divider} />}
          <div className={ctaBlock}>
            {title && (
              <h2>
                {nodeLocale.indexOf('jp') !== -1 ? preventOrphan(title) : title}
              </h2>
            )}
            {ctaUrl && ctaText && (
              <Link className={cta} to={ctaUrl}>
                {ctaText}
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductDetails
